/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamAdvanceRequest } from './oralExamAdvanceRequest';

export type AdvanceOralExamQuestionBody = OralExamAdvanceRequest | null;
